import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAnalytics } from './utils/analytics';

const root = ReactDOM.createRoot(document.getElementById('root'));
initAnalytics();
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
